<template>
	<div class="c-check" :class="{'z-chk': checkState, 'z-dis': disabled}" @click.stop="clickHandle">
		<img v-if="checkState" src="@/assets/image/check.png" alt="">
	</div>
</template>

<script>
	export default {
		name: 'cCheck',

		props: {
			value: [String, Number],
			stateValue: {
				type: Array,
				default() {
					return [1, 0];
				}
			},
			disabled: Boolean
		},

		data() {
			return {
				state: ''
			}
		},

		computed: {
			checkState() {
				return this.state == this.stateValue[0];
			}
		},

		watch: {
			value: {
				handler(val) {
					this.state = this.value;
				},
				immediate: true
			},
			
			state() {
				this.$emit('input', this.state);
			}
		},

		methods: {
			clickHandle() {
				if (this.disabled) return;
				this.state = this.stateValue[this.checkState ? 1 : 0];
				this.$emit('change', this.state);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-check {
		position: relative;
		box-sizing: border-box;
		width: 20px;
		height: 20px;
		border: 2px solid #ddd;
		border-radius: 4px;
		background: #fff;
		cursor: pointer;

		&:hover {
			border-color: #ccc;
		}

		&.z-chk {
			border-color: var(--color-main);
		}

		&.z-dis {
			background: #EDEDED;
			cursor: not-allowed;

			img {
				filter: grayscale(100%);
			}
		}

		img {
			position: absolute;
			left: 0;
			bottom: -2px;
			width: 24px;
			max-width: none;
			height: 24px;
			max-height: none;
		}
	}
</style>